import type { DeepPartial } from '@luna/utils-ts';

import type { DirectDebit } from './DirectDebit';

export const SK: DeepPartial<DirectDebit> = {};
